import { pagePolicy, canPermission } from './pagePolicies';
export const resourceForPage = path => pagePolicy(path)?.resources[0] || 'unassigned';
export const canPageAction = (user, path, action, resource) => {
  if (!user) return false;
  const resources = resource ? [resource] : pagePolicy(path)?.resources || [];
  return resources.some(base => (action === 'write' ? ['create', 'edit'] : [action]).some(a => canPermission(user, `${base}.${a}`)));
};
export const recordForPage = path => {
  const p = path.split('/').filter(Boolean);
  const aliases = { receipts:'govt_receipts', loans:'loans_v2', advances:'staff_advances', salary:'salary_slips', fd:'fd_master', bg:'bg_master', p2:'p2_deals', 'site-transfers':'site_transfers_v2', banks:'bank_accounts', 'access-control':'users' };
  let collection = p[0] === 'settings' || p[0] === 'admin' ? p[1] : p[0];
  collection = aliases[collection] || collection?.replaceAll('-', '_');
  if (collection === 'inventory' && p.includes('consumptions')) collection = 'stock_transactions';
  const recordId = p.find(value => /^[a-f\d]{8}-[a-f\d-]{27}$/i.test(value));
  return { module: collection, recordId };
};